import ora, { type Options } from "ora"
import { colors } from "@/src/utils/colors"

// Custom Tiptap-style spinner frames that resemble a typewriter cursor
const tiptapSpinner = {
  frames: [
    `${colors.cyan("█")}`, // Full block (cursor visible)
    `${colors.cyan("█")}`, // Full block (cursor visible)
    `${colors.cyan("█")}`, // Full block (cursor visible)
    ` `, // Space (cursor hidden)
    ` `, // Space (cursor hidden)
    ` `, // Space (cursor hidden)
  ],
  interval: 200, // Typewriter-like blinking speed
}

export function spinner(
  text: Options["text"],
  options?: {
    silent?: boolean
  }
) {
  return ora({
    text: text,
    spinner: tiptapSpinner,
    color: "cyan",
    isSilent: options?.silent,
  })
}
